const straps = [{
  id: 'mesh',
  name_pre: '',
  name: 'Milanese',
  name_post: 'Mesh',
  price_from: 'CHF 199',
  production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/strap_milanese_mesh.jpg?v=1626851785',
  compatible_models: ['archimedes', 'snow-star', 'lab-01'],
  variantId: 39274870407325
}, {
  id: 'blue-textile',
  name_pre: '',
  name: 'Blue',
  name_post: 'Textile',
  price_from: 'CHF 149',
  production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/strap_textile_blue.jpg?v=1618390220',
  compatible_models: ['archimedes', 'snow-star'],
  variantId: 37391670149277
}, {
  id: 'black-textile',
  name_pre: '',
  name: 'Black',
  name_post: 'Textile',
  price_from: 'CHF 169',
  production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/strap_textile_black.jpg?v=1618390220',
  compatible_models: ['archimedes', 'snow-star'],
  variantId: 37382039011485
}, {
  id: 'khaki-textile',
  name_pre: '',
  name: 'Khaki',
  name_post: 'Textile',
  price_from: 'CHF 169',
  production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/strap_textile_khaki.jpg?v=1618390220',
  compatible_models: ['archimedes', 'snow-star'],
  variantId: 33482988847236
}, {
  id: 'brown-leather',
  name_pre: '',
  name: 'Brown',
  name_post: 'Leather',
  price_from: 'CHF 149',
  production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/strap_leather_brown.jpg?v=1618390220',
  compatible_models: ['archimedes', 'snow-star'],
  variantId: 37382210060445
}, {
  id: 'black-leather',
  name_pre: '',
  name: 'Black',
  name_post: 'Leather',
  price_from: 'CHF 169',
  production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/strap_leather_black.jpg?v=1618390220',
  compatible_models: ['archimedes', 'snow-star'],
  variantId: 37751233773725
}, {
  id: 'beige-leather',
  name_pre: '',
  name: 'Beige',
  name_post: 'Leather',
  price_from: 'CHF 169',
  production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/strap_leather_beige.jpg?v=1618390220',
  compatible_models: ['archimedes', 'snow-star'],
  variantId: 37751211950237
}, {
  id: 'grey-leather',
  name_pre: '',
  name: 'Grey',
  name_post: 'Leather',
  price_from: 'CHF 169',
  production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/strap_leather_grey.jpg?v=1618390220',
  compatible_models: ['archimedes', 'snow-star'],
  variantId: 37751245602973
}, {
  id: 'blue-rubber',
  name_pre: '',
  name: 'Blue',
  name_post: 'Tropic Rubber',
  price_from: 'CHF 100',
  production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/strap_rubber_blue.jpg?v=1618390220',
  compatible_models: ['archimedes', 'snow-star'],
  variantId: 37391670149277
}, {
  id: 'black-rubber',
  name_pre: '',
  name: 'Black',
  name_post: 'Tropic Rubber',
  price_from: 'CHF 149',
  production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/strap_rubber_black.jpg?v=1618390220',
  compatible_models: ['archimedes', 'snow-star'],
  variantId: 37252876927133
}, {
  id: 'lab-01-black',
  name_pre: '',
  name: 'Black',
  name_post: 'Textile',
  price_from: 'CHF 149',
  production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/strap_lab-01_black.jpg?v=1618390220',
  compatible_models: ['lab-01'],
  variantId: 36971365007517
}, {
  id: 'lab-01-grey',
  name_pre: '',
  name: 'Grey',
  name_post: 'Textile',
  price_from: 'CHF 149',
  production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/strap_lab-01_grey.jpg?v=1618390220',
  compatible_models: ['lab-01'],
  variantId: 37650208751773
}, {
  id: 'lab-01-blue',
  name_pre: '',
  name: 'Blue',
  name_post: 'Textile',
  price_from: 'CHF 149',
  production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/strap_lab-01_blue.jpg?v=1618390220',
  compatible_models: ['lab-01'],
  variantId: 37650203246749
}, {
  id: 'nato-blue',
  name_pre: '',
  name: 'Blue',
  name_post: 'Nato',
  price_from: 'CHF 80',
  production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/products/MilusArchimedesnatostrap_1800x1800.jpg?v=1612252213',
  compatible_models: ['snow-star', 'archimedes'],
  variantId: 37751256318109
}, {
  id: 'nato-black',
  name_pre: '',
  name: 'Black',
  name_post: 'Nato',
  price_from: 'CHF 80',
  production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/products/BlackNatoStrap_1800x1800.png?v=1657291946',
  compatible_models: ['snow-star', 'archimedes'],
  variantId: 43282334384351
}]

export default straps;
